import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

const ApplicationPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [customerId, setCustomerId] = useState('');

  useEffect(() => {
    const id = searchParams.get('customerid');
    if (id) {
      setCustomerId(id);
    } else {
      // If no customerId, redirect to home
      setTimeout(() => {
        navigate('/');
      }, 3000);
    }
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-teal-50 to-white flex items-center justify-center px-4">
      <div className="max-w-2xl w-full bg-white rounded-2xl shadow-2xl p-8 md:p-12 text-center">
        <div className="mb-6 flex justify-center">
          <div className="bg-green-100 rounded-full p-6">
            <CheckCircle className="text-green-600" size={64} />
          </div>
        </div>
        
        <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
          Thank You!
        </h1>
        
        <p className="text-xl text-gray-600 mb-6 leading-relaxed">
          Your application has been submitted successfully.
        </p>
        
        {customerId && (
          <div className="bg-emerald-50 border-2 border-emerald-200 rounded-lg p-6 mb-6">
            <p className="text-sm text-gray-600 mb-2">Your Customer ID</p>
            <p className="text-3xl font-bold text-brand-primary">{customerId}</p>
          </div>
        )}
        
        <div className="space-y-4 text-left bg-gray-50 rounded-lg p-6">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">What's Next?</h2>
          <div className="space-y-3">
            <div className="flex items-start">
              <div className="bg-brand-primary text-white rounded-full w-6 h-6 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                1
              </div>
              <p className="text-base text-gray-700">
                Our trademark experts will review your application within 24 hours.
              </p>
            </div>
            <div className="flex items-start">
              <div className="bg-brand-primary text-white rounded-full w-6 h-6 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                2
              </div>
              <p className="text-base text-gray-700">
                You'll receive an email with detailed information about your trademark registration process.
              </p>
            </div>
            <div className="flex items-start">
              <div className="bg-brand-primary text-white rounded-full w-6 h-6 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                3
              </div>
              <p className="text-base text-gray-700">
                Our team will contact you to discuss next steps and answer any questions.
              </p>
            </div>
          </div>
        </div>
        
        <div className="mt-8">
          <button
            onClick={() => navigate('/')}
            className="bg-brand-gradient text-white px-8 py-3 rounded-lg font-semibold hover:opacity-90 transition-all shadow-lg"
          >
            Return to Home
          </button>
        </div>
        
        {customerId && (
          <p className="text-sm text-gray-500 mt-6">
            Please save your Customer ID for future reference
          </p>
        )}
      </div>
    </div>
  );
};

export default ApplicationPage;
